// ./client/src/components/Messages/SendSms.js
import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import useSmsTask from "../../hooks/useSmsTask";

const SendSms = ({ customerPhone, testMode = false }) => {
  const { job, user } = useAppContext();
  const { status, error, sendSms } = useSmsTask();
  const [text, setText] = useState("");

  const repName = user?.nickname || user?.full_name || "";
  const jobId = job?.id

  const handleChange = (e) => setText(e.target.value);

  const handleSend = (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    sendSms({
      customerPhone,
      text: text.trim(),
      jobId,
      repId: repName,
      testMode,
    });
  };

  const isBusy = ["Queued", "Sending"].includes(status);
  const hideForm =
    !testMode &&
    (!customerPhone || Number(user?.user_roles_id) > 1); // admin and developer only

  let feedback = "";
  if (isBusy) feedback = "Sending...";
  else if (status === "Delivered" || status === "Sent") feedback = "Message sent!";
  else if (status === "Failed") feedback = error || "Failed to send";

  if (hideForm) return null;

  return (
    <form className="form">
      <div className="form-center">
        <div className="form-row whole">
          <label htmlFor="sms-text" className="form-label">
            Message
          </label>
          <textarea
            id="sms-text"
            name="sms-text"
            className="form-textarea"
            value={text}
            onChange={handleChange}
            disabled={isBusy}
            rows={3}
          ></textarea>
        </div>
        <div className="btn-block whole">
          <button className="btn" onClick={handleSend} disabled={isBusy || !text.trim()}>
            {isBusy ? "Sending..." : "Send Text"}
          </button>
        </div>
        {feedback && (
          <div className="whole">
            <p className={status === "Failed" ? "text-red" : "text-green"}>{feedback}</p>
          </div>
        )}
      </div>
    </form>
  );
};

export default SendSms;
